import {
    GET_CUSTOMERS,
    GET_CUSTOMERS_SUCCESS,
    GET_CUSTOMERS_FAIL,
    ADD_NEW_CUSTOMER,
    ADD_NEW_CUSTOMER_SUCCESS,
    ADD_NEW_CUSTOMER_FAIL,
    UPDATE_CUSTOMER,
    UPDATE_CUSTOMER_SUCCESS,
    UPDATE_CUSTOMER_FAIL,
    DELETE_CUSTOMER,
    DELETE_CUSTOMER_SUCCESS,
    DELETE_CUSTOMER_FAIL,
    GET_CUSTOMER_DETAIL,
    GET_CUSTOMER_DETAIL_SUCCESS,
    GET_CUSTOMER_DETAIL_FAIL,
    EXPORT_CUSTOMERS,
    GET_CUSTOMER_CATEGORIES,
    GET_CUSTOMER_CATEGORIES_SUCCESS,
    GET_CUSTOMER_CATEGORIES_FAIL,
} from "./actionTypes"

export const getCustomerCategories = () => ({
    type: GET_CUSTOMER_CATEGORIES,
})

export const getCustomerCategoriesSuccess = categories => ({
    type: GET_CUSTOMER_CATEGORIES_SUCCESS,
    payload: categories,
})

export const getCustomerCategoriesFail = error => ({
    type: GET_CUSTOMER_CATEGORIES_FAIL,
    payload: error,
})

export const exportCustomersAction = () => ({
    type: EXPORT_CUSTOMERS,
})

export const getCustomers = (params) => ({
    type: GET_CUSTOMERS,
    payload: params,
})

export const getCustomersSuccess = (customers) => ({
    type: GET_CUSTOMERS_SUCCESS,
    payload: customers,
})

export const getCustomersFail = (error) => ({
    type: GET_CUSTOMERS_FAIL,
    payload: error,
})

export const addNewCustomer = (customer) => ({
    type: ADD_NEW_CUSTOMER,
    payload: customer,
})

export const addNewCustomerSuccess = (customer) => ({
    type: ADD_NEW_CUSTOMER_SUCCESS,
    payload: customer,
})

export const addNewCustomerFail = (error) => ({
    type: ADD_NEW_CUSTOMER_FAIL,
    payload: error,
})

export const updateCustomerAction = (customer) => ({
    type: UPDATE_CUSTOMER,
    payload: customer,
})

export const updateCustomerSuccess = (customer) => ({
    type: UPDATE_CUSTOMER_SUCCESS,
    payload: customer,
})

export const updateCustomerFail = (error) => ({
    type: UPDATE_CUSTOMER_FAIL,
    payload: error,
})

export const deleteCustomerAction = (id) => ({
    type: DELETE_CUSTOMER,
    payload: id,
})

export const deleteCustomerSuccess = (id) => ({
    type: DELETE_CUSTOMER_SUCCESS,
    payload: id,
})

export const deleteCustomerFail = (error) => ({
    type: DELETE_CUSTOMER_FAIL,
    payload: error,
})

export const getCustomerDetail = (id) => ({
    type: GET_CUSTOMER_DETAIL,
    payload: id,
})

export const getCustomerDetailSuccess = (customer) => ({
    type: GET_CUSTOMER_DETAIL_SUCCESS,
    payload: customer,
})

export const getCustomerDetailFail = (error) => ({
    type: GET_CUSTOMER_DETAIL_FAIL,
    payload: error,
})
